import styled, { css } from "styled-components";
import { useDesignTokens } from "@boi/react-design-tokens";
import { useViewportSize } from "@react-aria/utils";

export const Dialog = styled.dialog`
  ${() => {
    const { tokens } = useDesignTokens();
    const { modal } = tokens;

    return css`
      display: none;
      align-items: end;
      justify-items: center;
      width: 100%;
      max-width: none;
      height: 100%;
      max-height: none;
      border: none;
      padding: 0;
      background: none;
      outline: none;

      &[open] {
        display: grid;
      }

      @media (min-width: ${modal.breakpoints.tablet}) {
        align-items: center;
        max-width: calc(100vw - (${modal.padding.tablet} * 2));
        max-height: calc(100vh - (${modal.padding.tablet} * 2));
      }

      &::backdrop {
        background: ${modal.backdrop.backgroundColor};
      }
    `;
  }}
`;

export const ContainerBase = styled.div`
  ${() => {
    const { tokens } = useDesignTokens();
    const { modal } = tokens;

    const tabletMinHeight =
      parseInt(modal.maxHeight.tablet) +
      parseInt(modal.padding.tablet) * 2 +
      "px";

    return css`
      min-height: ${modal.minHeight.mobile};
      max-height: ${modal.maxHeight.mobile};
      overflow-wrap: anywhere;

      @media (min-width: ${modal.breakpoints.tablet}) {
        min-height: ${modal.minHeight.tablet};
        max-height: calc(100vh - (${modal.padding.tablet} * 2));

        @media (min-height: ${tabletMinHeight}) {
          max-height: ${modal.maxHeight.tablet};
        }
      }
    `;
  }}
`;

type ContainerProps = {
  $tabletWidth?: number;
};

export const Container = styled(ContainerBase)<ContainerProps>`
  ${({ $tabletWidth }) => {
    const { tokens } = useDesignTokens();
    const { modal } = tokens;
    const { width } = useViewportSize();

    const maxTabletWindowWidth = width - parseInt(modal.padding.tablet, 10) * 2;

    return css`
      width: ${modal.width.mobile};
      min-width: ${modal.minWidth.mobile};
      max-width: ${modal.maxWidth.mobile};
      border-top-left-radius: ${modal.radius};
      border-top-right-radius: ${modal.radius};
      background: ${modal.backgroundColor};
      overflow: hidden;

      @media (min-width: ${modal.breakpoints.tablet}) {
        width: ${$tabletWidth && $tabletWidth < maxTabletWindowWidth
          ? `${$tabletWidth}px`
          : modal.width.tablet};
        min-width: ${modal.minWidth.tablet};
        max-width: ${modal.maxWidth.tablet};
        border-bottom-left-radius: ${modal.radius};
        border-bottom-right-radius: ${modal.radius};
      }
    `;
  }}
`;
